import {Box, Button, Flex, Stack, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import classes from "../../sliceChatComponents/ChatInput.module.css";

export const ConversationLimitReached: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <Stack
            gap={0}
            className={classes.inputContainer}
            data-name="conversation-limit-reached"
        >
            <Box
                p="lg"
                bg="gneis.0"
                style={{borderRadius: "var(--mantine-radius-md)"}}
            >
                <Flex
                    direction={{base: "column", sm: "row"}}
                    justify="space-between"
                    align={{base: "stretch", sm: "center"}}
                    gap="md"
                >
                    <Stack gap={4}>
                        <Text fw={700}>{t("chat.limit.heading")}</Text>
                        <Text size="sm">{t("chat.limit.body")}</Text>
                    </Stack>
                    <Button
                        size="sm"
                        color="dark"
                        onClick={() => navigate("/")}
                        style={{flexShrink: 0}}
                    >
                        {t("chat.limit.button")}
                    </Button>
                </Flex>
            </Box>
        </Stack>
    );
};
